// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"8c357fd1","806":"c51cdfba"}[chunkId] + ".chunk.js";
};